import { Controller } from "@hotwired/stimulus"

// The customer enters whole major units (e.g. 71 for a EUR 71 voucher) while the
// backend stores cents. The visible input never shows cents; a hidden field
// carries the submitted cents value (digits + "00", no float math).
export default class extends Controller {
  static targets = ["input", "cents", "preset"]

  connect() {
    // The web component may not have hydrated its `value` property yet
    this.syncPresets(this.inputTarget.value || this.inputTarget.getAttribute("value") || "")
  }

  keydown(event) {
    if (event.key.length > 1 || event.ctrlKey || event.metaKey) return

    if (!/^\d$/.test(event.key)) {
      event.preventDefault()
    }
  }

  input() {
    const digits = (this.inputTarget.value || "")
      .replace(/\D/g, "")
      .replace(/^0+/, "")

    if (this.inputTarget.value !== digits) {
      this.inputTarget.value = digits
    }

    this.centsTarget.value = digits === "" ? "" : `${digits}00`
    this.syncPresets(digits)
  }

  preset(event) {
    const amount = event.params.amount.toString()
    this.inputTarget.value = this.inputTarget.value === amount ? "" : amount
    this.input()
  }

  // The chip toggles its own `checked` on click; this keeps all chips in
  // line with the typed amount as the single source of truth.
  syncPresets(amount) {
    this.presetTargets.forEach((chip) => {
      chip.checked = chip.dataset.denominationFieldAmountParam === amount
    })
  }
}
